export function normalizeEventParams(
  params: string | [string, ...any[]],
): [string, ...any[]] {
  return typeof params === 'string' ? [params] : params;
}

export const TRACK_FN = Symbol('TRACK_FN');
